
import AutoNumeric from 'autonumeric';
import { Component, Prop, Watch, Vue } from 'vue-property-decorator';

// @ts-ignore
import VTextField from 'vuetify/lib/components/VTextField/VTextField';

@Component({
  extends: VTextField,
})
export default class NumericField extends Vue {
  $refs!: {
    input: HTMLInputElement
  };

  @Prop()
  private numericType!: 'money' | 'percent' | 'score' | 'twoDigits' | 'decimal';

  @Prop({ default: '1000000' })
  private maxValue!: number|string;

  private anElement: AutoNumeric | null = null;
  private changedByInput: boolean = false;

  private get anOptions(): AutoNumeric.Options {
    switch (this.numericType) {
      case 'money':
        return {
          allowDecimalPadding: true,
          currencySymbol: 'R$ ',
          currencySymbolPlacement: 'p',
          decimalCharacter: ',',
          decimalCharacterAlternative: '.',
          decimalPlaces: 2,
          digitGroupSeparator: '.',
          emptyInputBehavior: 'null',
          maximumValue: this.maxValue ? String(this.maxValue) : '1000000',
          minimumValue: '0',
          modifyValueOnWheel: false,
        };

      case 'percent':
        return {
          allowDecimalPadding: false,
          currencySymbol: '%',
          currencySymbolPlacement: 's',
          decimalCharacter: ',',
          decimalPlaces: 2,
          digitGroupSeparator: '',
          emptyInputBehavior: 'null',
          maximumValue: '100',
          minimumValue: '0',
          modifyValueOnWheel: false,
        };

      case 'score':
        return {
          allowDecimalPadding: false,
          decimalPlaces: 0,
          digitGroupSeparator: '',
          emptyInputBehavior: 'null',
          maximumValue: '10',
          minimumValue: '0',
          modifyValueOnWheel: false,
        };

      case 'decimal':
        return {
          decimalPlaces: 2,
          minimumValue: '0',
          maximumValue: '1000000',
          emptyInputBehavior: 'null',
          modifyValueOnWheel: false,
          digitGroupSeparator: '',
          decimalCharacter: '.',
          decimalCharacterAlternative: '.',
        };

      case 'twoDigits':
        return {
          decimalPlaces: 0,
          digitGroupSeparator: '',
          emptyInputBehavior: 'null',
          maximumValue: '99',
          minimumValue: '0',
          modifyValueOnWheel: false,
        };

      default:
        return {
          decimalPlaces: 0,
          digitGroupSeparator: '',
          emptyInputBehavior: 'null',
          maximumValue: '1000000',
          minimumValue: '0',
          modifyValueOnWheel: false,
        };
    }
  }

  @Watch('value')
  onValueChange() {
    if (!this.changedByInput) {
      this.anElement && this.anElement.set((this as any).value);
    }
  }

  @Watch('numericType')
  onNumericTypeChange() {
    this.anElement && this.anElement.update(this.anOptions);
  }

  @Watch('anOptions')
  onNumericOptionsChange() {
    this.anElement && this.anElement.update(this.anOptions);
  }

  private onInput() {
    this.changedByInput = true;
    this.updateVModel();
  }

  private updateVModel() {
    if (this.anElement !== null) {
      this.$emit('input', this.anElement.getNumber());
    }
  }

  private genInput() {
    const listeners = Object.assign({}, (this as any).listeners$);

    delete listeners['change'];

    let element = this.$createElement('input', {
      style: {},
      attrs: {
        ...(this as any).attrs$,
        autofocus: (this as any).autofocus,
        disabled: (this as any).disabled,
        id: (this as any).computedId,
        placeholder: (this as any).placeholder,
        readonly: (this as any).readonly,
        type: (this as any).type
      },
      on: {
        blur: (this as any).onBlur,
        input: (this as any).onInput,
        focus: (this as any).onFocus,
        keydown: (this as any).onKeyDown,
        'autoNumeric:formatted': () => {
          this.changedByInput = false;
        }
      },
      ref: 'input'
    });
    return element;
  }

  focus() {
    this.$nextTick(() => {
      this.$refs.input.focus();
    });
  }

  mounted() {
    this.anElement = new AutoNumeric(this.$refs.input, undefined, this.anOptions);
    this.anElement.set((this as any).value);
  }
}
